// extracted by mini-css-extract-plugin
export default {"conferenceItem":"youtubeCard_conferenceItem__I5eyc","conferencesDescription":"youtubeCard_conferencesDescription__RpBNx"};